export const ORIGINAL_PDF_LIST = [
  {
    id: 'sn',
    name: 'Measuring Cell SerNo',
    type: 'number',
    disabled: true,
  },
  {
    id: 'sn_partner',
    name: 'Computer Box SerNo',
    type: 'string',
  },
  {
    id: 'space-2',
    name: 'space',
    type: 'space',
  },

  {
    id: 'schiffsname',
    name: 'Vessel Name',
    type: 'text',
  },
  {
    id: 'imo_nr',
    name: 'IMO Number',
    type: 'number',
  },
  {
    id: 'space-3',
    name: 'space',
    type: 'space',
  },

  {
    id: 'commissioning_date',
    name: 'Commissioning Date',
    type: 'date',
  },
  {
    id: 'space-4',
    name: 'space',
    type: 'space',
  },
  {
    id: 'space-5',
    name: 'space',
    type: 'space',
  },

  {
    id: 'pin',
    name: 'PIN Code',
    type: 'text',
  },
  {
    id: 'produktionsdatum',
    name: 'Date of production',
    type: 'month',
  },
  {
    id: 'email',
    name: 'E-Mail',
    type: 'text',
  },
];
